import axios from 'axios';
import { AthleteInfo, AthleteInfoCommand } from './models/athlete';
import { ImageResponse } from './models/common';

export async function getAthleteApi(athleteGuid: string): Promise<AthleteInfo> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `/api/v1/athlete/${athleteGuid}`;
    const response = await axios.get(baseUrl + endpoint, { timeout: 60000});
    return response.data as AthleteInfo;
  }

  export async function getAthleteProfileImageApi(athleteGuid: string): Promise<ImageResponse> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `/api/v1/athlete/${athleteGuid}/profile`;
    const response = await axios.get(baseUrl + endpoint, { timeout: 60000});
    return response.data as ImageResponse;
  }

  export async function updateAthleteApi(bearerToken:string, athleteGuid: string, athleteInfoCommand:AthleteInfoCommand): Promise<AthleteInfo> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `/api/v1/athlete/${athleteGuid}`;
    const response = await axios.post(baseUrl + endpoint, athleteInfoCommand, { timeout: 60000, headers: { 'Authorization': `Bearer ${bearerToken}` } });
    return response.data as AthleteInfo;
  }


  